import { useDispatch, useSelector } from "react-redux"
import { getQuoteRequest } from "../../../../Redux/action/getQuoteAction"
import { useFormik } from "formik"
import { getQuoteSchema } from "../../../../common/validation/getQuotesValidation"
import { Toast } from "../../../toastify"

const useQuote = () => {
  const dispatch = useDispatch()
  const { quote } = useSelector((state) => state.getQuote)

  async function submit(values, setSubmitting) {
    try {
      await dispatch(getQuoteRequest(values)).unwrap()
      Toast(
        "success",
        "Your Quotes has been recieved. We will surely get back to you shortly"
      )
    } catch (error) {
      Toast("error", error?.message)
    } finally {
      setSubmitting()
    }
  }

  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    errors,
    touched,
    isSubmitting,
  } = useFormik({
    initialValues: quote,
    validationSchema: getQuoteSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      // console.log("values:", values)
      submit(values, setSubmitting)
      resetForm()
    },
  })

  return {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    errors,
    touched,
    isSubmitting,
    
  }
}

export default useQuote
